import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mock';
import { Building2, Users } from 'lucide-react';

const About = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-amber-50 rounded-full mb-6">
              <span className="text-amber-600 font-semibold text-sm">{t.about.title}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              {language === 'ar' ? 'مكتب الدرر للمحاماة' : 'AL-DURAR LAW FIRM'}
            </h2>
            <div className="prose prose-lg max-w-none">
              {t.about.content.split('\n\n').map((paragraph, index) => (
                <p key={index} className="text-slate-600 mb-4 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Stats */}
            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-6 rounded-2xl border border-slate-200">
                <Users className="w-10 h-10 text-amber-600 mb-3" />
                <div className="text-2xl font-bold text-slate-900">500+</div>
                <div className="text-sm text-slate-600">{language === 'ar' ? 'عميل راض' : 'Happy Clients'}</div>
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-6 rounded-2xl border border-slate-200">
                <Building2 className="w-10 h-10 text-amber-600 mb-3" />
                <div className="text-2xl font-bold text-slate-900">15+</div>
                <div className="text-sm text-slate-600">{language === 'ar' ? 'سنة خبرة' : 'Years Experience'}</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative z-10 bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl p-12 shadow-2xl">
              <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 bg-slate-500/10 rounded-full blur-3xl"></div>
              
              <div className="relative space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center">
                      <span className="text-white font-bold text-xl">✓</span>
                    </div>
                    <div>
                      <div className="font-bold text-slate-900">{language === 'ar' ? 'مهنية عالية' : 'High Professionalism'}</div>
                      <div className="text-sm text-slate-600">{language === 'ar' ? 'التزام بالمعايير' : 'Committed Standards'}</div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-slate-600 to-slate-800 rounded-xl flex items-center justify-center">
                      <span className="text-white font-bold text-xl">✓</span>
                    </div>
                    <div>
                      <div className="font-bold text-slate-900">{language === 'ar' ? 'خبراء متخصصون' : 'Expert Attorneys'}</div>
                      <div className="text-sm text-slate-600">{language === 'ar' ? 'فريق ذو كفاءة' : 'Skilled Team'}</div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center">
                      <span className="text-white font-bold text-xl">✓</span>
                    </div>
                    <div>
                      <div className="font-bold text-slate-900">{language === 'ar' ? 'سرية تامة' : 'Full Confidentiality'}</div>
                      <div className="text-sm text-slate-600">{language === 'ar' ? 'حماية معلوماتك' : 'Protect Your Info'}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-amber-500 rounded-2xl opacity-10 -z-10"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-slate-700 rounded-2xl opacity-10 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;